import { createUseStyles } from 'react-jss';
import { LoaderProps } from './types';
import { Classes } from 'jss';
import { ActionPalette, BrandPalette, GrayscalePalette } from '@tcl-boron-colors/colors';

export const useLoaderStyles: (
  data?: LoaderProps & {
    theme?: Jss.Theme;
  },
) => Classes<
  | 'root'
  | 'spinner'
  | 'checkSvg'
  | 'spinnerChildFour'
  | 'spinnerChildThree'
  | 'spinnerChildOne'
  | 'spinnerChildTwo'
  | 'spinnerChildFive'
  | 'icon'
> = createUseStyles({
  root: {
    alignItems: 'center',
    borderRadius: '50%',
    boxSizing: 'border-box',
    display: 'flex',
    height: ({ size }: LoaderProps) => (size === 'small' ? '16px' : '24px'),
    justifyContent: 'center',
    overflow: 'hidden',
    transition: '0.8s background-color',
    width: ({ size }: LoaderProps) => (size === 'small' ? '16px' : '24px'),
  },
  checkSvg: {
    color: `${BrandPalette[700]}`,
    animation: 'checkScale 250ms ease-out',
    borderRadius: '50%',
    height: '16px',
    width: '16px',
  },
  spinner: {
    display: 'inline-block',
    position: 'relative',
    width: ({ size }: LoaderProps) => (size === 'small' ? '16px' : '24px'),
    height: ({ size }: LoaderProps) => (size === 'small' ? '16px' : '24px'),
  },
  spinnerChildOne: {
    boxSizing: 'border-box',
    display: 'block',
    position: 'absolute',
    width: ({ size }: LoaderProps) => (size === 'small' ? '16px' : '24px'),
    height: ({ size }: LoaderProps) => (size === 'small' ? '16px' : '24px'),
    borderWidth: ({ size }: LoaderProps) => (size === 'small' ? '2px' : '3px'),
    borderStyle: 'solid',
    borderRadius: '50%',
    animation: 'spinnerNew 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite',
    borderColor: `${BrandPalette[700]} transparent transparent transparent`,
  },
  spinnerChildTwo: {
    animationDelay: '-0.45s',
  },
  spinnerChildThree: {
    animationDelay: '-0.3s',
  },
  spinnerChildFour: {
    animationDelay: '-0.15s',
  },
  spinnerChildFive: {
    animationDelay: '-0.07s',
    borderColor: ({ loaderType }: LoaderProps) =>
      loaderType === 'primary' ? `${GrayscalePalette[100]}` : `${ActionPalette[400]}`,
    borderStyle: 'solid',
    borderWidth: ({ size }: LoaderProps) => (size === 'small' ? '2px' : '3px'),
  },
  icon: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
});
